export default {
	'3xl': '1900px',
	'2xl': '1400px',
	xl: '1280px',
	lg: '1024px',
	md: '768px',
	sm: '640px',
	xs: '360px'
};
